export const taxes = [
  { text: '21% - IVA General', value: '21' },
  { text: '12% - IVA Compensación', value: '12' },
  { text: '10,5% - IVA Compensación', value: '10.5' },
  { text: '10% - IVA Reducido', value: '10' },
  { text: '7,5% - IVA Reducido', value: '7.5' },
  { text: '7% - IGIC General', value: '7' },
  { text: '5% - IVA reducido', value: '5' },
  { text: '4% - IVA Super reducido', value: '4' },
  { text: '3% - IGIC Reducido', value: '3' },
  { text: '2% - IVA Super reducido', value: '2' },
  { text: '0% - Sin IVA/IGIC', value: '0' },
  { text: 'Exento de IVA/IGIC', value: null },
];

export const irpf = [
  { text: '19% - Alquiler urbano', value: '19' },
  { text: '15% - General', value: '15' },
  { text: '7% - Nuevos autónomos y otros', value: '7' },
  { text: '2% - Otras actividades', value: '2' },
  { text: '1% - Otras actividades', value: '1' },
  { text: '0% - Sin IRPF', value: '0' },
];
